/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

export const locusEventKeys = [
  'locus.summary',
  'locus.self_changed',
  'locus.participant_joined',
  'locus.participant_left',
  'locus.participant_declined',
  'locus.participant_alerted',
  'locus.participant_updated',
  'locus.participant_roles_updated',
  'locus.participant_audio_muted',
  'locus.participant_audio_unmuted',
  'locus.participant_video_muted',
  'locus.participant_video_unmuted',
  'locus.floor_granted',
  'locus.floor_released',
  'locus.space_users_modified',
  'locus.controls_updated',
  'locus.participant_controls_updated'
];

export default locusEventKeys;
